import Header from "./header"
let header;

export const initHeader = () => {
  if (!header) {
    header = new Header(document.querySelector('header'))
    header.init();
  }
}
